import React from 'react'

const footer = () => {
  return (
    <footer id="footer">
    <div className="container">
      <div className="copyright">
        2024 &copy; Copyright <strong><span>Vaishnavi</span></strong>. All Rights Reserved
      </div>
    </div>
  </footer>
  )
}

export default footer